import { useContext } from "react";
import { ModalContext, ModalContextType } from "../contexts/modalContext";

const useModal = (): ModalContextType => {
	const context = useContext(ModalContext);

	if (!context) {
		throw new Error('useModal must be used within a ModalProvider.');
	}

	return context;
};

export default useModal;
